import sizes from './sizes'
import colors from './colors'

export default {
  SP_LIGHT: {
    fontFamily: 'OpenSans Light, sans-serif',
    fontSize: sizes.DEFAULT_FONT_SIZE,
    color: colors.MAIN_COLOR,
    fontWeight: '300'
  },
  SP_REGULAR: {
    fontFamily: 'OpenSans Regular, sans-serif',
    fontSize: sizes.DEFAULT_FONT_SIZE,
    color: colors.MAIN_COLOR,
    fontWeight: '400'
  },
  SP_BOLD: {
    fontFamily: 'OpenSans Bold, sans-serif',
    fontSize: sizes.DEFAULT_FONT_SIZE,
    color: colors.MAIN_COLOR,
    fontWeight: '700'
  },
  SP_SEMIBOLD: {
    fontFamily: 'OpenSans SemiBold, sans-serif',
    fontSize: sizes.DEFAULT_FONT_SIZE,
    color: colors.MAIN_COLOR,
    fontWeight: '600'
  }
}
